<template>
  <div class="au-container" @click.stop>
    <img
      src="@/assets/clock/clockin_icon_start.png"
      alt=""
      class="icon-btn"
      @click="playAudio"
      v-show="!isPlayState || !isPlay"
    />
    <img
      src="@/assets/clock/clockin_icon_pause.png"
      alt=""
      class="icon-btn"
      @click="pauseAudio"
      v-show="isPlayState && isPlay"
    />
    <div class="progress" v-if="state !== 2">
      <Slider
        v-model="percentage"
        bar-height="4"
        button-size="10"
        active-color="#fff"
        inactive-color="#F08D40"
        @change="changeTime"
      />
    </div>
    <div class="time-text">{{ duration }}''</div>
    <div class="time-text" v-if="wxRecord && state === 2">上传失败</div>
    <div class="time-text" v-if="wxRecord && state === 0">
      <div class="run-circle-bg"></div>
      <div class="run-circle"></div>
    </div>

    <img
      src="@/assets/clockin_icon_sequel.png"
      alt=""
      class="fail"
      @click.stop="uploadRecord"
      v-if="state === 2"
    />
  </div>
</template>

<script>
import { Slider } from 'vant';
import { uploadWxRecord } from '@/api/clockin';
import { isIos } from '@/common/js/utils';

export default {
  props: {
    audioSrc: {
      type: String,
      required: true,
    },
    wxRecord: {
      // 播放的音频是否为微信录音
      type: Boolean,
      default: false,
    },
    wxDuration: {
      // 微信录制的音频时长，单位：秒
      type: Number,
      default: 0,
    },
  },
  components: {
    Slider,
  },
  data() {
    return {
      percentage: 0, // 进度条进度（0-100）
      duration: 0, // 音频时长
      isPlayState: false, // 是否处于播放状态
      audio: null, // 音频元素对象
      timer: null, // 定时器对象
      serverId: null, // 音频的服务器端ID
      url: '', // 上传视频后返回的音频链接
      state: 0, // 音频上传状态：0 上传中  1 上传成功  2上传失败
      loading: false
    };
  },
  watch: {
    state(val) {
      if (val === 1) {
        this.$emit('uploadSuccess', { id: this.audioSrc, url: this.url });
      }
    },
    isPlay(val) {
      // 播放的音频不是当前音频则清除定时器
      if (!val && this.timer) {
        clearInterval(this.timer);
      }
    }
  },
  computed: {
    isPlay() {
      return this.$store.state.audioEle === this.audio;
    }
  },
  mounted() {
    // 网络录音文件，则获取时长
    if (!this.wxRecord) {
      const audio = new Audio(this.audioSrc);
      audio.preload = 'metadata';
      this.audio = audio;

      if (localStorage.records) {
        const records = JSON.parse(localStorage.records);
        const idx = records.findIndex(item => item.url === this.audioSrc);

        if (idx !== -1) {
          this.duration = records[idx].duration;
          return;
        }
      }

      if (isIos()) {
        this.autoplayAudio(audio);
      }

      audio.addEventListener('loadeddata', this.setDuration);

      return;
    }

    // 上传录音
    this.uploadRecord();
  },
  methods: {
    // 播放音频
    playAudio() {
      if (!this.audio) {
        return;
      }

      // 判断是否有正在播放的音频对象，有则暂停
      if (this.$store.state.audioEle) {
        this.$store.state.audioEle.pause();
      }

      // 将当前正在播放的音频对象保存到vuex中
      this.$store.commit('SET_PLAY_AU', this.audio);

      // 播放音频，并修改状态
      this.audio.play();
      this.isPlayState = true;

      // 使用定时器每隔100毫秒修改一次进度条的进度
      this.timer = setInterval(() => {
        // 计算进度条进度
        this.percentage = (this.audio.currentTime / this.audio.duration) * 100;

        // 音频播放结束，则清除定时器并修改按钮状态
        if (this.audio.duration === this.audio.currentTime) {
          clearInterval(this.timer);
          this.isPlayState = false;

          // 播放结束则移除保存在vuex中的音频对象
          this.$store.commit('SET_PLAY_AU', null);
        }
      }, 100);
    },
    // 暂停播放音频
    pauseAudio() {
      if (!this.audio) {
        return;
      }

      // 暂停播放音频并清除定时器
      this.audio.pause();
      clearInterval(this.timer);

      // 暂停播放则移除保存在vuex中的音频对象
      this.$store.commit('SET_PLAY_AU', null);

      // 设置当前进度并修改按钮状态
      this.percentage = (this.audio.currentTime / this.audio.duration) * 100;
      this.isPlayState = false;
    },
    // 拖动音频进度条
    changeTime(value) {
      if (!this.audio) {
        return;
      }

      // 如果定时器存在则清除
      if (this.timer) {
        clearInterval(this.timer);
      }

      // 设置音频的当前时间，下次播放从这开始
      this.audio.currentTime = (value / 100) * this.audio.duration;
      this.playAudio();
    },
    /**
     * @description 上传音频到微信
     * @param {string} localId 微信录制的音频ID
     * @returns {promise} 成功resolve(serverId)，失败reject()
     */
    uploadAuWx(localId) {
      return new Promise((resolve, reject) => {
        // eslint-disable-next-line no-undef
        wx.uploadVoice({
          localId, // 需要上传的音频的本地ID
          isShowProgressTips: 0, // 默认为1，显示进度提示
          success(res) {
            const { serverId } = res; // 返回音频的服务器端ID
            resolve(serverId);
          },
          fail(err) {
            console.error('获取微信录音的服务端ID失败', err);
            reject();
          },
        });
      });
    },
    /**
     * @description 上传音频到服务器上
     * @param {string} serverId 上传音频到微信后，返回的serverId
     * @returns {promise} 成功resolve(url)，失败reject()
     */
    uploadAuServer(serverId) {
      return new Promise((resolve, reject) => {
        uploadWxRecord(serverId)
          .then((res) => {
            const { data } = res;

            if (!data.upload) {
              reject();
              return;
            }

            resolve(data.url);
          })
          .catch(() => {
            reject();
          });
      });
    },
    /**
     * @description 上传录音
     */
    async uploadRecord() {
      if (this.loading) {
        return;
      }
      this.state = 0;
      this.loading = true;

      if (!this.serverId) {
        const serverId = await this.uploadAuWx(this.audioSrc).catch(() => false);

        if (!serverId) {
          this.state = 2;
          this.loading = false;
          return;
        }

        this.serverId = serverId;
      }

      this.uploadAuServer(this.serverId)
        .then((url) => {
          this.url = url;
          this.state = 1;
          this.loading = false;

          const audio = new Audio(url);
          audio.preload = 'metadata';
          this.audio = audio;
          this.duration = this.wxDuration;
          this.saveRecordDuration(url, this.wxDuration.toString());
        })
        .catch(() => {
          this.state = 2;
          this.loading = false;
        });
    },
    /**
     * @description 自动静音播放音频并自动暂停
     * @param {object} audio 音频对象
     */
    autoplayAudio(audio) {
      try {
        // eslint-disable-next-line no-undef
        if ((typeof WeixinJSBridge) !== 'object' && (typeof WeixinJSBridge.invoke) !== 'function') {
          return;
        }

        // eslint-disable-next-line no-undef
        WeixinJSBridge.invoke('getNetworkType', {}, () => {
          audio.muted = true;
          audio.play();

          setTimeout(() => {
            audio.pause();
            audio.currentTime = 0;
            audio.muted = false;
          }, 1000);
        });
      } catch (ex) {
        console.error(ex, 'WeixinJSBridge');
      }
    },
    /**
     * @description 设置音频时长，并保存到本地存储
     */
    setDuration() {
      const { duration } = this.audio;
      this.duration = duration.toFixed();

      this.audio.removeEventListener('loadeddata', this.setDuration);

      // 将音频时长存储在本地
      this.saveRecordDuration(this.audioSrc, this.duration);
    },
    /**
     * @description 保存录音时长到本地存储
     * @param {string} url 音频链接
     * @param {string} duration 时长，单位秒
     */
    saveRecordDuration(url, duration) {
      if (typeof url !== 'string' || typeof duration !== 'string' || Number(duration) <= 0) {
        console.error('saveRecordDuration(): arguments error.');
        return;
      }

      const record = { url, duration };

      if (localStorage.records) {
        const oldRecords = JSON.parse(localStorage.records);

        if (oldRecords.length > 555) {
          oldRecords.splice(0, 444);
        }

        const idx = oldRecords.findIndex(item => item.url === url);

        if (idx === -1) {
          oldRecords.push(record);
          localStorage.records = JSON.stringify(oldRecords);
        }

        return;
      }

      localStorage.records = JSON.stringify([record]);
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.audio.pause();
    this.audio = null;
  },
};
</script>

<style lang="stylus" scoped>
.au-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  padding: 0 8px;
  box-sizing: border-box;
  width: 210px;
  height: 40px;
  background: #FF9645;
  border-radius: 8px;

  .audio-ele {
    position: absolute;
    top: 0;
    left: 0;
    width: 210px;
    height: 0;
  }

  .icon-btn {
    width: 24px;
  }

  .progress {
    width: 130px;
  }

  .time-text {
    position: relative;
    font-size: 15px;
    color: #fff;
  }
}

.run-circle-bg {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-radius: 50%;
}

.run-circle {
  position: absolute;
  top: 0;
  left: 0;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid #fff;
  border-bottom-color: transparent;
  border-left-color: transparent;
  border-right-color: transparent;
  animation: loading 2s linear 0s infinite normal;
}

@keyframes loading {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.fail {
  position absolute
  top: 11px;
  right: -26px;
  display: block;
  width: 18px;
  height: 18px;
  border: none;
}
</style>
